<template>
  <div v-if="!item.hidden" class="menu-item">
    <!-- <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="generateTitle(onlyOneChild.meta.title)" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title='generateTitle(item.meta.title)' />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu> -->

    <el-tooltip
      class="item"
      effect="dark"
      :content="generateTitle(item.meta.title)"
      open-delay="200"
      :disabled="sidebar.opened"
      placement="right"
    >
      <div class="item-top" :style="sidebar.opened?'cursor:pointer':'cursor:default'" v-if="item.meta" @click="handleChildSlide">
        <!-- <svg-icon :style="[sidebar.opened?'margin-left:8px':'margin: 0 auto',sidebar.opened&&isEN?'margin-left:0px !important':'',isEN?'margin-right:unset !important':' margin: 0 auto;']" :icon-class="item.meta.icon" @click="handleUnfold" /> -->
        <svg-icon :style="sidebar.opened?'margin-left:8px':'margin: 0 auto'" :class="isEN&&sidebar.opened?'en-menu-open':''" :icon-class="item.meta.icon" @click="handleUnfold" />
        <span class="meau-title" v-if="sidebar.opened">
          {{ generateTitle(item.name) }}
        </span>
        <svg-icon
          :style="isEN?'margin-right: 0px !important':''"
          class="arrow"
          v-show="sidebar.opened"
          :icon-class="append ? 'arrow-bottom' : 'arrow-right'"
        />
      </div>
    </el-tooltip>
    <div class="item-bottom" v-show="sidebar.opened">
      <ul v-if="append">
        <li
          v-for="child in item.children"
          :key="child.path"
          v-show="!child.hidden"
        >
          <app-link :to="resolvePath(child.path)">
            <span class="submenu-item" :style="isEN?'text-indent: 10px;':'text-indent: 30px;'">{{
              generateTitle(child.name)
            }}</span>
          </app-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import { generateTitle } from "@/utils/i18n";
// import Item from './Item'
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import { mapGetters } from "vuex";
import { getTime } from "@/utils";

export default {
  name: "SidebarItem",
  components: {
    // Item,
    AppLink,
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
    //   append: {
    //   type: Boolean,
    //   default:true,
    // },
  },
  created() {},
  computed: {
    ...mapGetters(["sidebar"]),
  },
  watch: {
    $route: {
      handler(newRouter) {
        this.curFullPath = newRouter.fullPath;
        this.cur = newRouter;

      },
      immediate: true,
    },
  },

  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {
      append: true,
      curFullPath: "",
      curUrlSeq: 0,
      cur: "",
      icons: {},
      isEN: false,
    };
  },
  methods: {
    openSideBar() {
      this.$emit("mouseEnterOpenSideBar");
    },
    handleChildSlide() {
     
      this.append = !this.append;
      // console.log(this.curUrlSeq,this.item.urlSeq)
      // this.curUrlSeq=this.item.urlSeq
      //      console.log(this.curUrlSeq,this.item.urlSeq)
      // console.log(this.item);
    },
    handleUnfold(){
      console.log('qqqqq')
    this.$store.dispatch("app/toggleSideBar");
    },
    generateTitle,
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
  },
  mounted() {
    if(this.$cookies.get('language')==='en'){
      this.isEN = true
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background-color: #fff;
  user-select: none;
  // border-right: 1px solid #121212;
  .item-top {
    font-size: 13px;
    width: 100%;

    height: 56px;
    // min-width: 54.5px;
    /* padding:0 8px; */
    /* padding-right: 5px; */
    color: #3f3f3f;
    background-color: #ffffff;
    line-height: 16px;
    display: flex;
    cursor: pointer;
    align-items: center;
    white-space: nowrap;

    // border-bottom: 1.4px solid #121212;
    .svg-icon {
      width: 18px;
      height: 18px;
      color: #8c8c8c;
     /*  margin: 0 auto; */
      /* margin-right: 0px !important; */
      // vertical-align: -0.15em;
      fill: currentColor;
    }

    .arrow {
      margin-left: auto;
      margin-right: 10px;
    }
  }
  .item-bottom {
    font-size: 13px;
    width: 100%;

    background-color: #fff;
    // border-bottom-color: #121212;
    // border-bottom: 1.4px solid #121212;
    ul {
      margin: 0;
      padding:0 8px;
      background-color: #fff;
      color: #8c8c8c;
      li {
        cursor: pointer;
        list-style: none;
      }
/*       li:nth-child(n + 2) {
        margin-top: 8px;
      } */
      .submenu-item {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: start;
        /* text-indent: 10px; */
        // border-radius: 10px;

        height: 40px;

        // background: linear-gradient(90deg, rgba(46, 136, 255, 0) 0%, rgba(45, 135, 254, 1) 100%);
        // background-blend-mode: normal;
        // mix-blend-mode: normal;
      }
      .submenu-item:hover {
        // background-color: #4ab4fe;
        color: #2e88ff;

        background: linear-gradient(
          90deg,
          rgba(46, 136, 255, 0) 0%,
          rgba(45, 135, 254, 1) 400%
        );
        color: #2e88ff;
        .icon {
          background: #ffffff;
        }
      }
      .icon {
        width: 5px;
        height: 5px;
        margin-right: 4px;
        border-radius: 50%;
        background: #929292;
        display: inline-block;
      }
    }
  }
}
.router-link-exact-active .submenu-item {
  background: linear-gradient(
    90deg,
    rgba(46, 136, 255, 0) 0%,
    rgba(45, 135, 254, 1) 400%
  );
  color: #2e88ff;
  border-right: 2px #2e88ff solid;
  .icon {
    background-color: #ffffff !important;
  }
}
.node-color {
  color: #4ab4fe !important;
}
.en-menu-open{
  margin-right:unset !important;
}
</style>
